import type { FieldDto } from "../../types/field";
import type { FormSubmissionDto } from "../../types/submission";
import { isDisplayFieldType } from "../formBuilder/apiFieldTypes";
import { fieldFromDto } from "../formBuilder/draft";
import { formatSubmissionValue } from "./formatSubmissionValue";
import {
  getSubmissionFieldValue,
  normalizeSubmissionData,
} from "./normalizeSubmission";

export type ExternalSubmissionViewRow = {
  key: string;
  label: string;
  value: string;
};

export function buildExternalSubmissionView(
  submission: FormSubmissionDto,
  fields: FieldDto[] = [],
  cityNames?: Record<string, string>,
): ExternalSubmissionViewRow[] {
  const visibleFields = [...fields]
    .filter((field) => !isDisplayFieldType(field.type))
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  const builderFields = visibleFields.map((field, index) =>
    fieldFromDto(field, index),
  );
  const options = {
    cityNames,
    ages: submission.ages,
    asOf: submission.createdAt ?? submission.created_at,
  };

  if (builderFields.length === 0) {
    return normalizeSubmissionData(submission.data, []).map((answer) => ({
      key: `field-${answer.field_id}`,
      label: `Поле #${answer.field_id}`,
      value: formatSubmissionValue(undefined, answer.value, options),
    }));
  }

  return builderFields.map((field) => ({
    key: field.clientId,
    label: field.label.trim() || field.name || `Поле #${field.id ?? ""}`,
    value: formatSubmissionValue(
      field,
      getSubmissionFieldValue(submission.data, field, builderFields),
      options,
    ),
  }));
}
